module.exports = __webpack_public_path__ + "static/favicon-f2a5a8d1e7d2c639543b627cf35760b9.ico";